/**
* DevExpress Dashboard (_choose-json-schema-page.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ChooseJsonSchemaPage, JsonDataSourceWizardPageId, _registerChooseJsonSchemaPage as _registerAnalyticChooseJsonSchemaPage } from '@devexpress/analytics-core/analytics-wizard';
export let JsonDataSourceWizardSettings = {
    allowObjectPropertiesAsRoot: true
};
export function _registerChooseJsonSchemaPage(factory, requestWrapper, parameters) {
    _registerAnalyticChooseJsonSchemaPage(factory, requestWrapper);
    var chooseJsonSchemaPageMeta = factory.getMetadata(JsonDataSourceWizardPageId.ChooseJsonSchemaPage);
    chooseJsonSchemaPageMeta.create = () => new ChooseJsonSchemaPage(requestWrapper, JsonDataSourceWizardSettings.allowObjectPropertiesAsRoot, {
        getParameters: () => parameters().map(parameter => {
            return {
                value: parameter.defaultValue(),
                name: parameter.name()
            };
        })
    });
}
